// Custom bike count input
const bikesCountForm = document.querySelectorAll(".bikesCountForm");
if (bikesCountForm) {
    document.querySelectorAll(".bikesCountForm").forEach(function (item) {
        var input = item.querySelector("input[type=\"number\"]"),
            btnUp = item.querySelector(".count-up"),
            btnDown = item.querySelector(".count-down"),
            min = input.getAttribute("min"),
            max = input.getAttribute("max");

        if (btnDown !== null) {
            btnDown.addEventListener("click", function () {
                var oldValue = parseFloat(input.value);
                var newVal = oldValue > min ? oldValue - 1 : oldValue;
                item.querySelector("input").value = newVal;
            });
        }

        if (btnUp !== null) {
            btnUp.addEventListener("click", function () {
                var oldValue = parseFloat(input.value);
                var newVal = oldValue + 1;
                item.querySelector("input").value = newVal;
            });
        }
    });
}
